import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@heroui/react';
import { IconChevronLeft } from '@tabler/icons-react';
import { trpc } from '@/lib/trpc';

export default function ActivityLotteryDashboardPage() {
  const navigate = useNavigate();
  const { id: activityId } = useParams<{ id: string }>();
  const { data: activity } = trpc.activities.get.useQuery(
    { id: activityId! },
    { enabled: !!activityId }
  );

  return (
    <div className="h-full min-h-0 w-full flex flex-col">
      <header className="border-border flex h-14 shrink-0 items-center border-b px-4">
        <Button isIconOnly variant="tertiary" className="mr-4" onPress={() => navigate("/activities")}>
          <IconChevronLeft className="size-6" stroke={1.5} />
        </Button>
        <h1 className="min-w-0 truncate text-2xl font-bold">
          {`${activity?.title ?? "活动"} · 抽奖大屏`}
        </h1>
      </header>
      <div className="w-full flex-1" />
    </div>
  );
}
